var _rect, _g, _circle, _path, _text, _rect2, _circle2, _text2, _text3, _rect3, _rect4, _rect5, _rect6, _circle3, _text4, _text5, _rect7, _rect8, _rect9, _rect0, _circle4, _text6, _text7, _rect1, _rect10, _rect11, _rect12, _circle5, _text8, _text9, _rect13, _rect14, _rect15, _rect16, _circle6, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentOperationalFrictionFragmentedWorkflowDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1020,
    height: 620,
    viewBox: "0 0 1020 620",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom development desktop fragmented workflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 996,
    height: 596,
    rx: 34,
    fill: "#07152A",
    stroke: "#294766",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6EB8F8",
    strokeOpacity: 0.42,
    strokeWidth: 2,
    strokeDasharray: "7 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 140L510 298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 140L510 298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 450L510 298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 450L510 298"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 298,
    r: 75,
    fill: "#0B1D35",
    stroke: "#FF2775",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487 275l46 46M533 275l-46 46",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 397,
    fill: "#FF91BA",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    textAnchor: "middle",
    fontWeight: 820,
    letterSpacing: 1.5
  }, "PROCESS GAP")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 260,
    height: 170,
    rx: 21,
    fill: "#0B2341",
    stroke: "#087CFF",
    strokeOpacity: 0.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 83,
    r: 6,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 88,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "INBOX")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 120,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Requests and approvals")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 146,
    width: 218,
    height: 7,
    rx: 3.5,
    fill: "#087CFF",
    opacity: 0.65
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 168,
    width: 200,
    height: 7,
    rx: 3.5,
    fill: "#087CFF",
    opacity: 0.53
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 190,
    width: 182,
    height: 7,
    rx: 3.5,
    fill: "#087CFF",
    opacity: 0.41000000000000003
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 55,
    width: 260,
    height: 170,
    rx: 21,
    fill: "#0B2341",
    stroke: "#30D6A1",
    strokeOpacity: 0.72
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 83,
    r: 6,
    fill: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 746,
    y: 88,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "SPREADSHEET")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 120,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Duplicate capture")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 146,
    width: 218,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1",
    opacity: 0.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 168,
    width: 200,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1",
    opacity: 0.53
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 190,
    width: 182,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1",
    opacity: 0.41000000000000003
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 365,
    width: 260,
    height: 170,
    rx: 21,
    fill: "#0B2341",
    stroke: "#FF2775",
    strokeOpacity: 0.72
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 393,
    r: 6,
    fill: "#FF2775"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 398,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "CHAT THREAD")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 430,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Unstructured decisions")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 456,
    width: 218,
    height: 7,
    rx: 3.5,
    fill: "#FF2775",
    opacity: 0.65
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 478,
    width: 200,
    height: 7,
    rx: 3.5,
    fill: "#FF2775",
    opacity: 0.53
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 500,
    width: 182,
    height: 7,
    rx: 3.5,
    fill: "#FF2775",
    opacity: 0.41000000000000003
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 705,
    y: 365,
    width: 260,
    height: 170,
    rx: 21,
    fill: "#0B2341",
    stroke: "#F5B642",
    strokeOpacity: 0.72
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 393,
    r: 6,
    fill: "#F5B642"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 746,
    y: 398,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "LEGACY PLATFORM")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 430,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Delayed reporting")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 456,
    width: 218,
    height: 7,
    rx: 3.5,
    fill: "#F5B642",
    opacity: 0.65
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 478,
    width: 200,
    height: 7,
    rx: 3.5,
    fill: "#F5B642",
    opacity: 0.53
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 500,
    width: 182,
    height: 7,
    rx: 3.5,
    fill: "#F5B642",
    opacity: 0.41000000000000003
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 530,
    width: 370,
    height: 54,
    rx: 15,
    fill: "#101E33",
    stroke: "#344E6A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 351,
    cy: 557,
    r: 5,
    fill: "#F5B642"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 562,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800
  }, "MANUAL RECONCILIATION REQUIRED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentOperationalFrictionFragmentedWorkflowDesktop);
export default __webpack_public_path__ + "static/media/custom-development-operational-friction-fragmented-workflow-desktop.ad93314cb91a6363508dfb35f5439866.svg";
export { ForwardRef as ReactComponent };